import { FC, Fragment, PropsWithChildren } from 'react';
import { Box, Stack, styled } from '@mui/material';

import { ToolbarOffset } from '@components/base';
import AppHeader from '@components/layout/AppHeader';
import AppMenu from '@components/layout/AppHeader/AppMenu';
import DetailPanels from '@components/layout/DetailPanel';

const Main = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

export const AppLayout: FC<PropsWithChildren> = ({ children }) => (
  <Fragment>
    <AppHeader />

    <Stack direction='row' height='100vh'>
      <AppMenu open />

      <Stack minWidth={0} width={1}>
        <ToolbarOffset />

        <Main>
          {children}
          <DetailPanels />
        </Main>
      </Stack>
    </Stack>
  </Fragment>
);
